import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Collapse } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import axios from 'axios';
import ServicoFrame from './ServicoFrame';
import { getUsuario } from "../utils/LoginManager";

const { Item: ItemForm } = Form;
const Panel = Collapse.Panel;


export const OPCOES_COMBO_CST_IBS_CBS = [
  { key: '000', label: '000 - TRIBUTAÇÃO INTEGRAL' },
  { key: '010', label: '010 - TRIBUTAÇÃO COM ALÍQUOTAS UNIFORMES – OPERAÇÕES SETOR FINANCEIRO (INSERIDO)' },
  { key: '011', label: '011 - TRIBUTAÇÃO COM ALÍQUOTAS UNIFORMES REDUZIDAS EM 30% e 60% (INSERIDO)' },
  { key: '200', label: '200 - ALÍQUOTA ZERO OU REDUZIDA' },
  { key: '210', label: '210 - ALÍQUOTA REDUZIDA EM 50% E 70% COM REDUTOR DE BASE DE CÁLCULO' },
  { key: '220', label: '220 - ALÍQUOTA FIXA' },
  { key: '221', label: '221 - ALÍQUOTA FIXA PROPORCIONAL' },
  { key: '222', label: '222 - REDUÇÃO DE BASE DE CÁLCULO' },
  { key: '400', label: '400 - ISENÇÃO' },
  { key: '410', label: '410 - IMUNIDADE E NÃO INCIDÊNCIA' },
  { key: '510', label: '510 - DIFERIMENTO' },
  { key: '550', label: '550 - SUSPENSÃO' },
  { key: '620', label: '620 - TRIBUTAÇÃO MONOFÁSICA' },
  { key: '800', label: '800 - TRANSFERÊNCIA DE CRÉDITO' },
  { key: '810', label: '810 - AJUSTES' },
  { key: '820', label: '820 - TRIBUTAÇÃO EM DECLARAÇÃO DE REGIME ESPECÍFICO' },
  { key: '830', label: '830 - Exclusão de base de cálculo' },
]


export default class NotaFiscalServicoItemForm extends Component {
  state = {
    editando: false,

    listaServicos: [],

    registro: {}
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.servicoSelecionado !== propsAnterior.servicoSelecionado) {
      // console.log('componentDidUpdate', this.props.servicoSelecionado)
      this.setState({
        registro: this.props.servicoSelecionado.registro,
        listaServicos: this.props.servicoSelecionado.listaServicos ? this.props.servicoSelecionado.listaServicos : [],
        editando: this.props.servicoSelecionado.editando,
      }, () => {
        if (this.props.servicoSelecionado.registro.nfs_seq === 0) {
          this.onBuscaParametros();
        }
        this.forceUpdate()
      })
    };
  }


  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario }, this.getListaRegistros);
  }




  onBuscaParametros = () => {
    this.setState({ listaParTributacao: [], listaParCFOP: [] })

    axios.get('/parametros/parametros_nfe_tributacao')
      .then(response => {
        console.log('onBuscaParametros', response.data)
        this.setState({
          listaParTributacao: response.data,
          registro: {
            ...this.state.registro,
            nfs_cst: { key: response.data.pnfet_cst_ibs_cbs ? String(response.data.pnfet_cst_ibs_cbs).padStart(3, '0') : '' },
            nfs_sit_trib_ibs_cbs: response.data.pnfet_sit_trib_ibs_cbs ? String(response.data.pnfet_sit_trib_ibs_cbs) : '',

            nfs_perc_iss: response.data.pnfet_piss ? response.data.pnfet_piss : 0,

            nfs_pibs_mun: response.data.pnfet_pibs_mun ? response.data.pnfet_pibs_mun : 0,
            nfs_pibs_est: response.data.pnfet_pibs_est ? response.data.pnfet_pibs_est : 0,
            nfs_pcbs: response.data.pnfet_pcbs ? response.data.pnfet_pcbs : 0,
          },
        })
      }).catch(error => {
        console.error(error.response);
      })

    axios.get('/parametros/parametros_nfe_cfop')
      .then(response => {
        this.setState({
          listaParCFOP: response.data,
        })
      }).catch(error => {
        console.error(error.response);
      })
  };

  onOK = () => {

    const { registro, listaServicos } = this.state;

    if ((!registro.nfs_servico) || (registro.nfs_servico.key === '0') || (registro.nfs_servico.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Serviço', });
      return;
    }
    if (!registro.nfs_cod_servico) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Código do Serviço', });
      return;
    }
    if (!registro.nfs_cod_nbs) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Código NBS', });
      return;
    }

    const vlrTotalAux = parseFloat(registro.nfs_vlr_total);
    if (!vlrTotalAux) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Valor' });
      return;
    }
    if (!registro.nfs_qtde) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Quantidade' });
      return;
    }

    if ((!registro.nfs_sit_trib_ibs_cbs) || (registro.nfs_sit_trib_ibs_cbs === '0') || (registro.nfs_sit_trib_ibs_cbs === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Situação Tributárias do IBS/CBS', });
      return;
    }


    let iIndItem = -1;
    if (registro.nfs_seq >= 0) {
      for (var x in listaServicos) {
        if (String(listaServicos[x].nfs_seq) === String(registro.nfs_seq)) {
          iIndItem = x;
        }
      }
    }

    if (parseInt(iIndItem) >= 0) {

      this.state.listaServicos[iIndItem] = {
        ...this.state.listaServicos[iIndItem],

        nfs_cod_servico: registro.nfs_cod_servico,
        nfs_cod_nbs: registro.nfs_cod_nbs,

        nfs_qtde: parseFloat(registro.nfs_qtde),
        nfs_vlr_unit: parseFloat(registro.nfs_vlr_unit),
        nfs_perc_desc: parseFloat(registro.nfs_perc_desc === '' ? '0' : registro.nfs_perc_desc),
        nfs_vlr_desc: parseFloat(registro.nfs_vlr_desc === '' ? '0' : registro.nfs_vlr_desc),
        nfs_vlr_total: parseFloat(registro.nfs_vlr_total),

        nfs_bc_iss: registro.nfs_bc_iss,
        nfs_perc_iss: registro.nfs_perc_iss,
        nfs_vlr_iss: registro.nfs_vlr_iss,

        nfs_bc_csll: registro.nfs_bc_csll,
        nfs_perc_csll: registro.nfs_perc_csll,
        nfs_vlr_csll: registro.nfs_vlr_csll,

        nfs_bc_inss: registro.nfs_bc_inss,
        nfs_perc_inss: registro.nfs_perc_inss,
        nfs_vlr_inss: registro.nfs_vlr_inss,

        nfs_bc_irrf: registro.nfs_bc_irrf,
        nfs_perc_irrf: registro.nfs_perc_irrf,
        nfs_vlr_irrf: registro.nfs_vlr_irrf,

        nfs_cst: registro.nfs_cst.key,
        nfs_sit_trib_ibs_cbs: registro.nfs_sit_trib_ibs_cbs,
        nfs_bc: registro.nfs_bc,
        nfs_pibs_mun: registro.nfs_pibs_mun,
        nfs_vibs_mun: registro.nfs_vibs_mun,
        nfs_pibs_est: registro.nfs_pibs_est,
        nfs_vibs_est: registro.nfs_vibs_est,
        nfs_pcbs: registro.nfs_pcbs,
        nfs_vcbs: registro.nfs_vcbs,
      };


    } else {


      this.state.listaServicos.push({
        nfs_seq: this.state.listaServicos.length + 1,
        nfs_servico: registro.nfs_servico.key,
        nfs_descricao: registro.nfs_servico.label,
        nfs_cod_servico: registro.nfs_cod_servico,
        nfs_cod_nbs: registro.nfs_cod_nbs,

        nfs_qtde: parseFloat(registro.nfs_qtde),
        nfs_vlr_unit: parseFloat(registro.nfs_vlr_unit),
        nfs_perc_desc: parseFloat(registro.nfs_perc_desc === '' ? '0' : registro.nfs_perc_desc),
        nfs_vlr_desc: parseFloat(registro.nfs_vlr_desc === '' ? '0' : registro.nfs_vlr_desc),
        nfs_vlr_total: parseFloat(registro.nfs_vlr_total),

        nfs_bc_iss: registro.nfs_bc_iss,
        nfs_perc_iss: registro.nfs_perc_iss,
        nfs_vlr_iss: registro.nfs_vlr_iss,

        nfs_bc_csll: registro.nfs_bc_csll,
        nfs_perc_csll: registro.nfs_perc_csll,
        nfs_vlr_csll: registro.nfs_vlr_csll,

        nfs_bc_inss: registro.nfs_bc_inss,
        nfs_perc_inss: registro.nfs_perc_inss,
        nfs_vlr_inss: registro.nfs_vlr_inss,

        nfs_bc_irrf: registro.nfs_bc_irrf,
        nfs_perc_irrf: registro.nfs_perc_irrf,
        nfs_vlr_irrf: registro.nfs_vlr_irrf,

        nfs_cst: registro.nfs_cst.key,
        nfs_sit_trib_ibs_cbs: registro.nfs_sit_trib_ibs_cbs,
        nfs_bc: registro.nfs_bc,
        nfs_pibs_mun: registro.nfs_pibs_mun,
        nfs_vibs_mun: registro.nfs_vibs_mun,
        nfs_pibs_est: registro.nfs_pibs_est,
        nfs_vibs_est: registro.nfs_vibs_est,
        nfs_pcbs: registro.nfs_pcbs,
        nfs_vcbs: registro.nfs_vcbs,
      });

    }

    this.props.onSalvarServicoClick(this.state.listaServicos);
  };




  onChangeServico = event => {
    // console.log('onChangeServico: ', event);
    const { registro } = this.state;

    registro['nfs_servico'] = event.nfs_servico;
    registro['nfs_cod_servico'] = event.nfs_servico.serv_cod_nfse;
    registro['nfs_cod_nbs'] = event.nfs_servico.serv_cod_nbs;
    registro['nfs_vlr_unit'] = parseFloat(event.nfs_servico.serv_valor);

    registro['nfs_bc_iss'] = parseFloat(event.nfs_servico.serv_valor);
    registro['nfs_perc_iss'] = parseFloat(event.nfs_servico.serv_aliq_nfse);
    registro['nfs_vlr_iss'] = parseFloat(event.nfs_servico.serv_valor) * (parseFloat(event.nfs_servico.serv_aliq_nfse) / 100);

    this.calculoItem(registro.nfs_qtde, parseFloat(event.nfs_servico.serv_valor), registro.nfs_perc_desc, registro.nfs_vlr_desc);

    this.setState({
      registro
    });
  }


  calculoItem = (nfs_qtde, nfs_vlr_unit, nfs_perc_desc, nfs_vlr_desc) => {
    const { registro } = this.state;
    const vlrUnit = parseFloat(nfs_vlr_unit);
    const qtde = parseFloat(nfs_qtde);

    let percDesc = parseFloat(nfs_perc_desc);
    let vlrDesc = parseFloat(nfs_vlr_desc);

    if (vlrDesc === 0) {
      percDesc = nfs_perc_desc ? (parseFloat(nfs_perc_desc) / 100) : 0;
      vlrDesc = parseFloat((parseFloat(nfs_qtde) * parseFloat(vlrUnit)) * percDesc);
    }

    let vlrTotal = parseFloat(parseFloat(vlrUnit) * parseFloat(qtde)) - parseFloat(vlrDesc);

    if (registro.nfs_perc_iss > 0) {
      registro.nfs_bc_iss = parseFloat(vlrTotal);
      registro.nfs_vlr_iss = parseFloat((parseFloat(vlrTotal) * (parseFloat(registro.nfs_bc_iss) / 100)));
    }
    if (registro.nfs_perc_csll > 0) {
      registro.nfs_bc_csll = parseFloat(vlrTotal);
      registro.nfs_vlr_csll = parseFloat((parseFloat(vlrTotal) * (parseFloat(registro.nfs_perc_csll) / 100)));
    }
    if (registro.nfs_perc_inss > 0) {
      registro.nfs_bc_inss = parseFloat(vlrTotal);
      registro.nfs_vlr_inss = parseFloat((parseFloat(vlrTotal) * (parseFloat(registro.nfs_perc_inss) / 100)));
    }
    if (registro.nfs_perc_irrf > 0) {
      registro.nfs_bc_irrf = parseFloat(vlrTotal);
      registro.nfs_vlr_irrf = parseFloat((parseFloat(vlrTotal) * (parseFloat(registro.nfs_perc_irrf) / 100)));
    }
    if (registro.nfs_pibs_mun > 0) {
      registro.nfs_bc = parseFloat(vlrTotal);
      registro.nfs_vibs_mun = parseFloat((parseFloat(vlrTotal) * (parseFloat(registro.nfs_pibs_mun) / 100)));
    }
    if (registro.nfs_pibs_est > 0) {
      registro.nfs_bc = parseFloat(vlrTotal);
      registro.nfs_vibs_est = parseFloat((parseFloat(vlrTotal) * (parseFloat(registro.nfs_pibs_est) / 100)));
    }
    if (registro.nfs_pcbs > 0) {
      registro.nfs_bc = parseFloat(vlrTotal);
      registro.nfs_vcbs = parseFloat((parseFloat(vlrTotal) * (parseFloat(registro.nfs_pcbs) / 100)));
    }


    registro.nfs_vlr_total = vlrTotal;
    registro.nfs_vlr_desc = vlrDesc;
    this.setState({
      registro
    });
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({ [id]: value });

    console.log('onChange', event.target)
    console.log('onChange', registro)


    if (id === 'nfs_qtde') {
      registro.nfs_vlr_total = parseFloat(((value * (parseFloat(this.state.registro.nfs_vlr_unit))) - (parseFloat(this.state.registro.nfs_vlr_desc))).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfs_vlr_unit') {
      registro.nfs_vlr_total = parseFloat(((value * (parseFloat(this.state.registro.nfs_qtde))) - (parseFloat(this.state.registro.nfs_vlr_desc))).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfs_perc_desc') {
      const percDesc = value / 100;
      const vlrDesc = parseFloat((parseFloat(this.state.registro.nfs_vlr_unit) * parseFloat(this.state.registro.nfs_qtde)) * percDesc);

      registro.nfs_vlr_desc = vlrDesc;
      registro.nfs_vlr_total = parseFloat((((parseFloat(this.state.registro.nfs_qtde)) * (parseFloat(this.state.registro.nfs_vlr_unit))) - (vlrDesc)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfs_vlr_desc') {
      registro.nfs_vlr_total = parseFloat((((parseFloat(this.state.registro.nfs_qtde)) * (parseFloat(this.state.registro.nfs_vlr_unit))) - (value)).toFixed(2));
      this.setState({
        registro
      });
    }


    if ((id === 'nfs_qtde') || (id === 'nfs_vlr_unit') || (id === 'nfs_perc_desc') || (id === 'nfs_vlr_desc')) {
      if (registro.nfs_perc_iss > 0) {
        registro.nfs_bc_iss = parseFloat(registro.nfs_vlr_total);
        registro.nfs_vlr_iss = parseFloat((parseFloat(registro.nfs_vlr_total) * (parseFloat(registro.nfs_perc_iss) / 100)));
      }
      if (registro.nfs_perc_csll > 0) {
        registro.nfs_bc_csll = parseFloat(registro.nfs_vlr_total);
        registro.nfs_vlr_csll = parseFloat((parseFloat(registro.nfs_vlr_total) * (parseFloat(registro.nfs_perc_csll) / 100)));
      }
      if (registro.nfs_perc_inss > 0) {
        registro.nfs_bc_inss = parseFloat(registro.nfs_vlr_total);
        registro.nfs_vlr_inss = parseFloat((parseFloat(registro.nfs_vlr_total) * (parseFloat(registro.nfs_perc_inss) / 100)));
      }
      if (registro.nfs_perc_irrf > 0) {
        registro.nfs_bc_irrf = parseFloat(registro.nfs_vlr_total);
        registro.nfs_vlr_irrf = parseFloat((parseFloat(registro.nfs_vlr_total) * (parseFloat(registro.nfs_perc_irrf) / 100)));
      }
      if (registro.nfs_pibs_mun > 0) {
        registro.nfs_bc = parseFloat(registro.nfs_vlr_total);
        registro.nfs_vibs_mun = parseFloat((parseFloat(registro.nfs_vlr_total) * (parseFloat(registro.nfs_pibs_mun) / 100)));
      }
      if (registro.nfs_pibs_est > 0) {
        registro.nfs_bc = parseFloat(registro.nfs_vlr_total);
        registro.nfs_vibs_est = parseFloat((parseFloat(registro.nfs_vlr_total) * (parseFloat(registro.nfs_pibs_est) / 100)));
      }
      if (registro.nfs_pcbs > 0) {
        registro.nfs_bc = parseFloat(registro.nfs_vlr_total);
        registro.nfs_vcbs = parseFloat((parseFloat(registro.nfs_vlr_total) * (parseFloat(registro.nfs_pcbs) / 100)));
      }
    }

    if (id === 'nfs_bc_iss') {
      registro.nfs_vlr_iss = parseFloat((value * (parseFloat(this.state.registro.nfs_perc_iss) / 100)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfs_perc_iss') {
      registro.nfs_vlr_iss = parseFloat((parseFloat(this.state.registro.nfs_bc_iss) * (value / 100)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfs_bc_csll') {
      registro.nfs_vlr_csll = parseFloat((value * (parseFloat(this.state.registro.nfs_perc_csll) / 100)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfs_perc_csll') {
      registro.nfs_vlr_csll = parseFloat((parseFloat(this.state.registro.nfs_bc_csll) * (value / 100)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfs_bc_inss') {
      registro.nfs_vlr_inss = parseFloat((value * (parseFloat(this.state.registro.nfs_perc_inss) / 100)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfs_perc_inss') {
      registro.nfs_vlr_inss = parseFloat((parseFloat(this.state.registro.nfs_bc_inss) * (value / 100)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfs_bc_irrf') {
      registro.nfs_vlr_irrf = parseFloat((value * (parseFloat(this.state.registro.nfs_perc_irrf) / 100)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfs_perc_irrf') {
      registro.nfs_vlr_irrf = parseFloat((parseFloat(this.state.registro.nfs_bc_irrf) * (value / 100)).toFixed(2));
      this.setState({
        registro
      });
    }
  };










  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------


  render() {
    const { onFecharModalServicoClick, visivel } = this.props;

    const { editando } = this.state;
    const { nfs_seq, nfs_servico, nfs_descricao, nfs_cod_servico, nfs_cod_nbs, nfs_qtde, nfs_vlr_unit, nfs_perc_desc, nfs_vlr_desc, nfs_vlr_total,
      nfs_bc_iss, nfs_perc_iss, nfs_vlr_iss, nfs_bc_csll, nfs_perc_csll, nfs_vlr_csll, nfs_bc_inss, nfs_perc_inss, nfs_vlr_inss, nfs_bc_irrf, nfs_perc_irrf, nfs_vlr_irrf,
      nfs_cst, nfs_sit_trib_ibs_cbs, nfs_bc, nfs_pibs_mun, nfs_vibs_mun, nfs_pibs_est, nfs_vibs_est, nfs_pcbs, nfs_vcbs
    } = this.state.registro;

    console.log('NotaFiscalServicoItemForm.this.state: ', this.state);

    return (
      <Modal
        title={editando ? "Editar Serviço da Nota" : "Incluir Serviço da Nota"}
        visible={visivel}
        destroyOnClose
        onCancel={onFecharModalServicoClick}
        footer={null}
        width={"50%"}
        style={{ top: 20 }}
      >
        <div>

          <Row>
            <Col xs={24} >
              {nfs_seq ? (
                <div>
                  <span>Serviço</span>
                  <InputForm
                    id="nfs_descricao"
                    ref="nfs_descricao"
                    onChange={this.onChange}
                    value={nfs_descricao}
                    disabled={true}
                  />
                </div>
              ) : (
                <ServicoFrame
                  label="Serviço"
                  id="nfs_servico"
                  value={nfs_servico}
                  width={"100%"}
                  onChange={this.onChangeServico}
                />
              )}
            </Col>
            <Col xs={24} sm={4} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Qtde</span>
              <InputForm
                type="number"
                id="nfs_qtde"
                ref="nfs_qtde"
                value={nfs_qtde}
                onChange={this.onChange}
              />
            </Col>

            <Col xs={24} sm={5} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Valor Unitário</span>
              <InputForm
                type="number"
                id="nfs_vlr_unit"
                ref="nfs_vlr_unit"
                value={nfs_vlr_unit}
                onChange={this.onChange}
              />
            </Col>

            <Col xs={24} sm={5} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Desc (%)</span>
              <InputForm
                type="number"
                id="nfs_perc_desc"
                ref="nfs_perc_desc"
                value={nfs_perc_desc}
                onChange={this.onChange}
              />
            </Col>
            <Col xs={24} sm={5} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Valor Desconto</span>
              <InputForm
                type="number"
                id="nfs_vlr_desc"
                ref="nfs_vlr_desc"
                value={nfs_vlr_desc}
                onChange={this.onChange}
              />
            </Col>

            <Col xs={24} sm={5} style={{ marginTop: -20 }}>
              <span>Valor Total</span>
              <InputForm
                type="number"
                id="nfs_vlr_total"
                ref="nfs_vlr_total"
                value={nfs_vlr_total}
                onChange={this.onChange}
                disabled={true}
              />
            </Col>

            <Col xs={24} sm={4} style={{ marginTop: -20, paddingRight: 20 }} >
              <span>Cód. Serviço</span>
              <InputForm
                id="nfs_cod_servico"
                ref="nfs_cod_servico"
                maxLength={9}
                onChange={this.onChange}
                value={nfs_cod_servico}
              />
            </Col>
            <Col xs={24} sm={4} style={{ marginTop: -20, paddingRight: 20 }} >
              <span>Cód. NBS</span>
              <InputForm
                id="nfs_cod_nbs"
                ref="nfs_cod_nbs"
                maxLength={9}
                onChange={this.onChange}
                value={nfs_cod_nbs}
              />
            </Col>
          </Row>

          <Row>
            <Collapse>
              <Panel header={<span style={{ fontSize: 20, fontWeight: 'bold' }}>Impostos</span>} key="1">
                <Row>
                  <Col xs={24} sm={8} style={{ marginTop: 10, paddingRight: 20 }}>
                    <span>BC ISS</span>
                    <InputForm
                      type="number"
                      id="nfs_bc_iss"
                      ref="nfs_bc_iss"
                      value={nfs_bc_iss}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={8} style={{ marginTop: 10, paddingRight: 20 }}>
                    <span>Alíquita ISS</span>
                    <InputForm
                      type="number"
                      id="nfs_perc_iss"
                      ref="nfs_perc_iss"
                      value={nfs_perc_iss}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={8} style={{ marginTop: 10 }}>
                    <span>Valor ISS</span>
                    <InputForm
                      type="number"
                      id="nfs_vlr_iss"
                      ref="nfs_vlr_iss"
                      value={nfs_vlr_iss}
                      disabled={true}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>BC CSLL</span>
                    <InputForm
                      type="number"
                      id="nfs_bc_csll"
                      ref="nfs_bc_csll"
                      value={nfs_bc_csll}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>Alíquita CSLL</span>
                    <InputForm
                      type="number"
                      id="nfs_perc_csll"
                      ref="nfs_perc_csll"
                      value={nfs_perc_csll}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={8} style={{ marginTop: -20 }}>
                    <span>Valor ICMS ST</span>
                    <InputForm
                      type="number"
                      id="nfs_vlr_csll"
                      ref="nfs_vlr_csll"
                      value={nfs_vlr_csll}
                      disabled={true}
                    />
                  </Col>
                </Row>


                <Row>
                  <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>BC INSS</span>
                    <InputForm
                      type="number"
                      id="nfs_bc_inss"
                      ref="nfs_bc_inss"
                      value={nfs_bc_inss}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>Alíquita INSS</span>
                    <InputForm
                      type="number"
                      id="nfs_perc_inss"
                      ref="nfs_perc_inss"
                      value={nfs_perc_inss}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={8} style={{ marginTop: -20 }}>
                    <span>Valor INSS</span>
                    <InputForm
                      type="number"
                      id="nfs_vlr_inss"
                      ref="nfs_vlr_inss"
                      value={nfs_vlr_inss}
                      disabled={true}
                    />
                  </Col>
                </Row>


                <Row>
                  <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>BC IRRF</span>
                    <InputForm
                      type="number"
                      id="nfs_bc_irrf"
                      ref="nfs_bc_irrf"
                      value={nfs_bc_irrf}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>Alíquita IRRF</span>
                    <InputForm
                      type="number"
                      id="nfs_perc_irrf"
                      ref="nfs_perc_irrf"
                      value={nfs_perc_irrf}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={8} style={{ marginTop: -20 }}>
                    <span>Valor IRRF</span>
                    <InputForm
                      type="number"
                      id="nfs_vlr_irrf"
                      ref="nfs_vlr_irrf"
                      value={nfs_vlr_irrf}
                      disabled={true}
                    />
                  </Col>
                </Row>


                <Row>
                  <Col xs={24} sm={24} style={{ marginTop: -10 }} >
                    <span>CST IBS/CBS</span>
                    <InputForm
                      type="select"
                      id="nfs_cst"
                      ref="nfs_cst"
                      value={nfs_cst}
                      placeholder="Selecione"
                      onChange={this.onChange}
                      data={OPCOES_COMBO_CST_IBS_CBS}
                      validator={value => Boolean(value)}
                      style={{ width: "100%" }}
                    />
                  </Col>
                  <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }} >
                    <span>Situação Tributária</span>
                    <InputForm
                      id="nfs_sit_trib_ibs_cbs"
                      ref="nfs_sit_trib_ibs_cbs"
                      maxLength={9}
                      onChange={this.onChange}
                      value={nfs_sit_trib_ibs_cbs}
                    />
                  </Col>
                  <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>BC IBS/CBS</span>
                    <InputForm
                      type="number"
                      id="nfs_bc"
                      ref="nfs_bc"
                      value={nfs_bc}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>Alíquita IBS Mun.</span>
                    <InputForm
                      type="number"
                      id="nfs_pibs_mun"
                      ref="nfs_pibs_mun"
                      value={nfs_pibs_mun}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={6} style={{ marginTop: -20 }}>
                    <span>Valor IBS Mun.</span>
                    <InputForm
                      type="number"
                      id="nfs_vibs_mun"
                      ref="nfs_vibs_mun"
                      value={nfs_vibs_mun}
                      disabled={true}
                    />
                  </Col>
                  <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>Alíquita IBS Est.</span>
                    <InputForm
                      type="number"
                      id="nfs_pibs_est"
                      ref="nfs_pibs_est"
                      value={nfs_pibs_est}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>Valor IBS Est.</span>
                    <InputForm
                      type="number"
                      id="nfs_vibs_est"
                      ref="nfs_vibs_est"
                      value={nfs_vibs_est}
                      disabled={true}
                    />
                  </Col>
                  <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>Alíquita CBS</span>
                    <InputForm
                      type="number"
                      id="nfs_pcbs"
                      ref="nfs_pcbs"
                      value={nfs_pcbs}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={6} style={{ marginTop: -20 }}>
                    <span>Valor CBS</span>
                    <InputForm
                      type="number"
                      id="nfs_vcbs"
                      ref="nfs_vcbs"
                      value={nfs_vcbs}
                      disabled={true}
                    />
                  </Col>
                </Row>

              </Panel>
            </Collapse>
          </Row>


          <ItemForm>
            <div className="divider-form" />
            <Row>
              <Col xs={24}>
                {this.props.servicoSelecionado && this.props.servicoSelecionado.visualizar ? null : (
                  <Button
                    type="primary"
                    htmlType="button"
                    onClick={this.onOK}
                    className="btn-salvar"
                  >
                    Salvar
                  </Button>
                )}

                <Button
                  htmlType="button"
                  onClick={onFecharModalServicoClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>


      </Modal >



    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NotaFiscalServicoItemForm.js